export const FOOD_SENSITIVITY_TEST_SLUGS = [
  'food-sensitivity',
  'food-sensitivity-expansion',
];

export const GIFT_GUIDE_CATEGORY = {
  label: 'Gift Guide',
  url: `/gift-guide`,
};

export const EVERLYWELL_PLUS_CATEGORY = {
  label: 'Everlywell+',
  url: '/monthly-at-home-lab-testing-membership',
  displayBadge: true,
  badgeText: 'New',
};

export const PRODUCT_SLUGS = {
  FOOD_SENSITIVITY_PKI: 'food-sensitivity',
  FOOD_SENSITIVITY_COMPREHENSIVE: 'food-sensitivity-comprehensive-test',
  WOMENS_HEALTH: 'womens-health-test',
  THYROID: 'thyroid-test',
  COVID: 'covid-19-test',
  COVID_ELLUME: 'covid-ellume-rapid-test',
  COVID_QUIDEL: 'covid-quidel-rapid-test',
  COVID_BD: 'covid-bd-veritor-rapid-test',
  STD_IN_PERSON_TEST_EXPANDED: 'std-in-person-test-expanded',
  STD_IN_PERSON_TEST_BASIC: 'std-in-person-test-basic',
  CHLAMYDIA_GONORRHEA_IN_PERSON_TEST: 'chlamydia-gonorrhea-in-person-test',
  HIV_IN_PERSON_TEST: 'hiv-in-person-test',
};

export const VARIANT_SKUS = {
  COVID: 'covid-19-ew',
  COVID_BD: 'covid-bd-veritor-rapid-test',
};

/**
 * top 5 product IDs in order
 */
export const top5 = [
  PRODUCT_SLUGS.FOOD_SENSITIVITY_PKI,
  PRODUCT_SLUGS.FOOD_SENSITIVITY_COMPREHENSIVE,
  PRODUCT_SLUGS.COVID,
  PRODUCT_SLUGS.WOMENS_HEALTH,
  PRODUCT_SLUGS.THYROID,
];

export const COVID_SLUGS = [
  PRODUCT_SLUGS.COVID,
  PRODUCT_SLUGS.COVID_ELLUME,
  PRODUCT_SLUGS.COVID_QUIDEL,
  PRODUCT_SLUGS.COVID_BD,
];

export const PHONE_NUMBER_NEEDED_SKUS = [VARIANT_SKUS.COVID];

export const VITAMINS = [
  'multivitamin-gummy',
  'vitamin-b12-500-mcg',
  'vitamin-b6-50-mg',
  'vitamin-d3-2000-iu',
  'omega-3-fish-oil-1000-mg',
];

export const ELIMINATION_DIET_COACHING_SLUG = 'elimination-diet-coaching';

export const NO_INDEX_SLUGS = ['members/consentandnotice'];

export const QUEST_SLUGS = [
  PRODUCT_SLUGS.STD_IN_PERSON_TEST_EXPANDED,
  PRODUCT_SLUGS.STD_IN_PERSON_TEST_BASIC,
  PRODUCT_SLUGS.CHLAMYDIA_GONORRHEA_IN_PERSON_TEST,
  PRODUCT_SLUGS.HIV_IN_PERSON_TEST,
];
